import React from 'react';
import moment from 'moment';

class CountdownTimer extends React.Component {
    state = {
        days: undefined,
        hours: undefined,
        minutes: undefined,
        seconds: undefined
    };

    componentDidMount() {
        this.interval = setInterval(() => {
            const { timeTillDate, timeFormat } = this.props;
            const then = moment(timeTillDate);
            const now = moment();
            const countdown = moment.duration(then.diff(now));
            //const countdown = moment(then - now);
            const days = then.diff(now,'days') > 0 ? ("0" + then.diff(now,'days')).slice(-2) : '00';
            const hours = countdown.hours() > 0 ? ("0" + countdown.hours()).slice(-2) : '00';
            const minutes = countdown.minutes() > 0 ? ("0" + countdown.minutes()).slice(-2) : '00';
            const seconds = countdown.seconds() > 0 ? ("0" + countdown.seconds()).slice(-2) : '00';

            this.setState({ days, hours, minutes, seconds });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { days, hours, minutes, seconds } = this.state;

        return (
          <div className="d-flex flex-row justify-content-center">
          <p className="m-0 timer text-center pr-1">{days}<small className="d-block">Days</small></p>
          <p className="m-0 timer text-center">:</p>
          <p className="m-0 timer text-center pl-1 pr-1">{hours}<small className="d-block">Hours</small></p>
          <p className="m-0 timer text-center">:</p>
          <p className="m-0 timer text-center pl-1 pr-1">{minutes}<small className="d-block">Minutes</small></p>
          <p className="m-0 timer text-center">:</p>
          <p className="m-0 timer text-center pl-1">{seconds}<small className="d-block">Seconds</small></p>
        </div>
        );
    }
}

export default CountdownTimer;